import {isStaff} from '@github-ui/stats'

// Microsoft staff org IDs — mirrors the list in copilot-mission-control
// (internal/session/dotcom/client.go msStaffOrgIDs).
const MS_STAFF_ORG_IDS: ReadonlySet<string> = new Set([
  '6154722', // microsoft
  '6844498', // Azure
  '107488659', // MicrosoftCopilot
  '113467149', // ms-copilot
  '217663494', // argos-gh
])

/**
 * Returns true if the current user is GitHub staff or belongs to a Microsoft
 * staff SSO org. Used to relax the remote-control policy gate for internal
 * dogfooding while mission-control remains the enforcement boundary.
 */
export function isInternalStaff(ssoOrgIds?: string[]): boolean {
  if (isStaff()) return true
  if (!ssoOrgIds || ssoOrgIds.length === 0) return false
  return ssoOrgIds.some(id => MS_STAFF_ORG_IDS.has(id))
}
